module.exports = __webpack_public_path__ + "img/bloc-inici-consumibles.ea692b9e.jpg";